import { Box, Divider, Stack, Typography } from "@mui/material";
import { NEED_HELP_LINKS } from "../../../Constants/constants";
import {
  CardHeading,
  CardsContainer,
  SpacerSmall,
  StyledA,
  StyledElement,
} from "../../../Styles/GlobalStyles";
export const NeedHelpCard = () => {
  const needHelpLinks = NEED_HELP_LINKS;

  return (
    <>
      <Box>
        <CardHeading>Need help?</CardHeading>
        <CardsContainer>
          {needHelpLinks?.map(({ heading, name, path }: any, index: number) => {
            const isFirstChild = index === 0;
            return (
              <Stack spacing={1} key={name}>
                {!isFirstChild && (
                  <>
                    <SpacerSmall />
                    <Divider />
                  </>
                )}
                <Typography fontSize={"14px"} component={"p"}>
                  {heading}
                </Typography>
                {name === "REPORT SERVICE ISSUE" ? (
                  <StyledElement
                    onClick={path}
                    fontSize={"14px"}
                    style={{ cursor: "pointer", textDecoration: "underline" }}>
                    {name}
                  </StyledElement>
                ) : (
                  <StyledA target="_blank" href={path}>
                    <StyledElement fontSize={"14px"}>{name}</StyledElement>
                  </StyledA>
                )}
              </Stack>
            );
          })}
        </CardsContainer>
      </Box>
    </>
  );
};
